import { MachineApi } from './api/machine-api.service';
import { VemioApi }   from './api/vemio-api.service';
import { DeviceApi }  from './api/device-api.service';
import { Injectable } from "@angular/core";
import {CartApi}      from './api/cart-api.service';
import {OrderApi}     from './api/order-api.service';
import {PaymentApi}   from './api/payment-api.service';
import { DataApi }    from './api/data-api.service';
import {DebugApi}     from './api/debug-api.service';
import { SystemApi }  from "./api/system-api.service";
import { ExportApi } from "./api/export-api.service";

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	constructor(public cartApi: CartApi,
				public dataApi: DataApi,
				public debugApi: DebugApi,
				public deviceApi: DeviceApi,
				public exportApi: ExportApi,
				public machineApi: MachineApi,
				public orderApi: OrderApi,
				public paymentApi: PaymentApi,
				public systemApi: SystemApi,
				public vemioApi: VemioApi) {
	}

}
